<div>
  <h2 id="title" class="subheading-01-bold">
    Se procederá a recalcular todos los movimientos de caja de la oficina
    {{ value.office.agency }} para el año {{ value.year }}.
  </h2>
  <h2 id="title" class="subheading-01-bold">¿Desea proceder?</h2>
</div>
